<template>
  <div class="personalise">
    <div class="personalise__image">
      <picture>
        <img :src="`${excursion.imageUrl}?format=webp`" :alt="excursion.name" loading="lazy"/>
      </picture>  
    </div>
    <div class="personalise__content">
      <h3>{{excursion.name}}</h3>

      <p
        v-if="showFullText || excursion.description.length <= this.exceptLength"
        v-html="excursion.description"
      ></p>
      <p v-else v-html="$options.filters.truncate(excursion.description, this.exceptLength, '...')"></p>

      <div
        v-if="excursion.description.length > this.exceptLength"
        @click="toggleDescription"
        class="personalise__read"
        :class="{ 'personalise__read--less': showFullText }"
        role="button"
        tabindex="0"
        :aria-expanded="showFullText"
        :aria-label="showFullText ? data.readLessText : data.readMoreText"
      >{{showFullText ? data.readLessText : data.readMoreText}}</div>

      <!-- Default slot allows actions to exist (checkout & account) -->
      <slot></slot>

      <div class="personalise__footer">
        <div class="personalise__price tour-price">
          <div class="tour-price__days">
            <strong :class="{ 'tour-price__days_label': brand === Brand.Travelsphere }">{{data.priceLabel}}</strong>
          </div>
          <div class="tour-price__value">{{excursion.priceFormatted}}</div>
        </div>
        <!-- Add at checkout message for Tour page only -->
        <span class="personalise__message" v-if="!isCheckoutPage">{{data.addAtCheckoutText}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {Brand} from './../../../brand.js';

export default {
  props: ['excursion', 'data', 'brand'],

  data: function() {
    return {
      showFullText: false,
      exceptLength: 180,
      Brand
    };
  },

  computed: mapState('checkout', ['isCheckoutPage']),

  filters: {
    truncate: function(text, length, suffix) {
      return text.substring(0, length) + suffix;
    }
  },

  methods: {
    toggleDescription: function() {
      this.showFullText = !this.showFullText;
    }
  }
};
</script>